/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import Icons from '../../assets/icons/indexSVG';
import { ReactComponent as IconInputChecked } from '../../assets/icons/icon_input_checked.svg';
import { ReactComponent as IconStore } from '../../assets/icons/icon_store.svg';
import { ReactComponent as IconProductNav } from '../../assets/icons/icon_product_navigation.svg';
import { ReactComponent as IconReportsNav } from '../../assets/icons/icon_reports_navigation.svg';
import { ReactComponent as IconPOSNav } from '../../assets/icons/icon_pos_navigation.svg';
import { ReactComponent as IconDashboardNav } from '../../assets/icons/icon_dashboard_navigation.svg';
import { ReactComponent as IconAccountNav } from '../../assets/icons/icon_account_navigation.svg';
import { ReactComponent as IconPOSTerminal } from '../../assets/icons/icon_pos_terminal.svg';
import { ReactComponent as IconActionsNav } from '../../assets/icons/icon_actions_navigation.svg';
import { ReactComponent as IconSearch } from '../../assets/icons/icon_search.svg';
import { ReactComponent as IconBarcodeScan } from '../../assets/icons/icon-barcode-scan.svg';
import { ReactComponent as IconFilter } from '../../assets/icons/icon_filter.svg';
import { ReactComponent as IconTableDetails } from '../../assets/icons/icon_table_details.svg';
import { ReactComponent as IconTableEdit } from '../../assets/icons/icon_table_edit.svg';
import { ReactComponent as IconTableDelete } from '../../assets/icons/icon_table_delete.svg';
import { ReactComponent as IconSort } from '../../assets/icons/icon_sort.svg';
import { ReactComponent as IconUserGroupNav } from '../../assets/icons/icon_user_group_navigation.svg';
import { ReactComponent as IconTableAddInventory } from '../../assets/icons/icon_table_add_inventory.svg';
import { ReactComponent as IconSelectCaret } from '../../assets/icons/icon_select_caret.svg';
import { ReactComponent as IconHintHelp } from '../../assets/icons/icon_hint_help.svg';
import { ReactComponent as IconCallSupport } from '../../assets/icons/icon_call_support.svg';
import { ReactComponent as IconSettingsNav } from '../../assets/icons/icon_settings_navigation.svg';
import { ReactComponent as IconWallet } from '../../assets/icons/icon_wallet.svg';
import { ReactComponent as IconPriceTag } from '../../assets/icons/icon_pricetag.svg';
import { ReactComponent as IconGmail } from '../../assets/icons/icon_gmail.svg';
import { ReactComponent as IconSuppliersNav } from '../../assets/icons/icon_suppliers_navigation.svg';
import { ReactComponent as IconCash } from '../../assets/icons/icon_cash.svg';

type IconProps = {
  id: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
};

const allIcons: Record<
  string,
  (props: React.SVGProps<SVGSVGElement>) => JSX.Element | any
> = {
  ...Icons,
  iconInputChecked: IconInputChecked,
  iconStore: IconStore,
  iconProductNav: IconProductNav,
  iconReportsNav: IconReportsNav,
  iconPOSNav: IconPOSNav,
  iconDashboardNav: IconDashboardNav,
  iconAccountNav: IconAccountNav,
  iconPOSTerminal: IconPOSTerminal,
  iconSearch: IconSearch,
  iconBarcodeScan: IconBarcodeScan,
  iconActionsNav: IconActionsNav,
  iconFilter: IconFilter,
  iconTableDetails: IconTableDetails,
  iconTableEdit: IconTableEdit,
  iconTableDelete: IconTableDelete,
  iconSort: IconSort,
  iconUserGroupNav: IconUserGroupNav,
  iconTableAddInventory: IconTableAddInventory,
  iconSelectCaret: IconSelectCaret,
  iconHintHelp: IconHintHelp,
  iconCallSupport: IconCallSupport,
  iconSettingsNav: IconSettingsNav,
  iconWallet: IconWallet,
  iconPriceTag: IconPriceTag,
  iconGmail: IconGmail,
  iconSuppliersNav: IconSuppliersNav,
  iconCash: IconCash,
};

function Icon({ id, ...rest }: IconProps) {
  const SelectedIcon = allIcons[id];
  return SelectedIcon ? <SelectedIcon id={id} {...rest} /> : null;
}

Icon.defaultProps = {
  className: '',
  style: undefined,
  onClick: () => false,
};

export default Icon;
